export default __webpack_public_path__ + "static/media/b15.e781e37a.png";